import { diagnosticsApi, type DxNamedMasterDto } from "@/api/diagnostics";
import { MasterListPage } from "./MasterListPage";
import { MasterFormPage } from "./MasterFormPage";
import { statusColumn, TextFieldCell, SwitchCell } from "./fields";

const BASE = "/diagnostics/rejection-reasons";
const LIST_KEY = ["dx-rejection-reasons"];

export function DiagnosticsRejectionReasonsPage() {
  return (
    <MasterListPage<DxNamedMasterDto>
      breadcrumbs={["Diagnostics", "Masters"]}
      title="Sample-rejection reasons"
      subtitle="Why a collected sample was rejected — cited on the sample's audit trail."
      queryKey={LIST_KEY}
      listFn={(inc) => diagnosticsApi.listRejectionReasons(inc)}
      deleteFn={diagnosticsApi.deleteRejectionReason}
      basePath={BASE}
      newLabel="New reason"
      labelOf={(r) => r.name}
      deleteNote="It will be refused if any past sample rejection cites it, since that is an audit record."
      columns={[
        { field: "code", headerName: "Code", width: 160 },
        { field: "name", headerName: "Reason", flex: 1, minWidth: 240 },
        statusColumn<DxNamedMasterDto>(),
      ]}
    />
  );
}

interface Values { code: string; name: string; isActive: boolean }

export function RejectionReasonFormPage() {
  return (
    <MasterFormPage<Values, DxNamedMasterDto>
      breadcrumbs={["Diagnostics", "Rejection reasons"]}
      noun="rejection reason"
      basePath={BASE}
      listQueryKey={LIST_KEY}
      detailQueryKey={(id) => ["dx-rejection-reason", id]}
      defaultValues={{ code: "", name: "", isActive: true }}
      getFn={diagnosticsApi.getRejectionReason}
      toValues={(d) => ({ code: d.code, name: d.name, isActive: d.isActive })}
      createFn={(v) => diagnosticsApi.createRejectionReason({ code: v.code.trim(), name: v.name.trim() })}
      updateFn={(id, v) => diagnosticsApi.updateRejectionReason(id, { code: v.code.trim(), name: v.name.trim(), isActive: v.isActive })}
    >
      {({ control }, isEdit) => (
        <>
          <TextFieldCell control={control} name="code" label="Code" span={4} required />
          <TextFieldCell control={control} name="name" label="Reason" span={8} required />
          {isEdit && <SwitchCell control={control} name="isActive" label="Active" />}
        </>
      )}
    </MasterFormPage>
  );
}
